<template>
  <FullModal ref="FullModal" @close="close">
    <div class="details-page" v-loading="loading">
      <LableContent label="企业定额明细">
        <QuotaList :basicInfo="basicInfo" />
      </LableContent>

      <LableContent label="历史数据" hasCollapse showFullScreen>
        <QuotaHistory :basicInfo="basicInfo" />
      </LableContent>
    </div>
  </FullModal>
</template>

<script>
import FullModal from '@/components/FullModal/index.vue'
import LableContent from '@/components/LableContent/index.vue'
import QuotaList from './QuotaList.vue'
import QuotaHistory from './QuotaHistory.vue'

export default {
  name: 'HistoryDetails',
  components: {
    FullModal,
    LableContent,
    QuotaList,
    QuotaHistory
  },
  provide() {
    return {
      detailsVm: this
    }
  },
  data() {
    return {
      // 页面数据
      basicInfo: {
        sysCreatedDate: '2026-05-06',
        id: '2051906297677807617',
        updateContent: '1111111'
      },
      form: [],
      loading: false
    }
  },

  created() {},
  mounted() {
    // 页面初始化逻辑
  },
  methods: {
    // 页面方法
    show(row) {
      this.basicInfo = { id: row.id }
      this.$refs.FullModal.show({
        width: '100%',
        height: '100%',
        showConfirm: false,
        title: null,
        fullscreen: true,
        closeOnPressEscape: false
      })
    },

    close() {
      this.$emit('close')
      this.basicInfo = {}
    }
  }
}
</script>

<style scoped lang="less">
.details-page {
  padding-top: 10px;

  .base-info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    row-gap: 16px;
    width: 100%;
    .base-info-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      flex-wrap: wrap;
      width: 32%;
      color: #000;
      &:nth-child(3n -1) {
        margin: 0 2%;
      }
      .label {
        width: 142px;
        text-align: right;
        margin-right: 16px;
      }
      .value {
        height: 32px;
        flex: 1;
        background-color: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding-left: 6px;
        border: 1px solid #2a7ca7;
      }
    }
  }
}
</style>
